import { useContext, useEffect, useState } from "react"

import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock"
import styled from "styled-components"

import RoundButton from "components/buttons/RoundButton"
import { PopUpContext } from "components/Providers"
import colors from "styles/colors"
import media from "styles/media"
import useMedia from "utils/useMedia"

interface ModalProps {
  children: React.ReactNode
  open: boolean
  setOpen: (value: string) => void
  setShow: (value: boolean) => void
  disableScrollOnOpen?: boolean
}

export default function Modal({
  children,
  open,
  setOpen,
  setShow,
  disableScrollOnOpen = true,
}: ModalProps) {
  const [wrapperRef, setWrapperRef] = useState<HTMLDialogElement | null>(null)
  const large = useMedia(false, false, true, false)
  const { setOpenPopUp, setCanStart } = useContext(PopUpContext)
  const [wrapperHeight, setWrapperHeight] = useState(0)

  const handleClose = () => {
    setOpen("")
    setShow(true)
  }

  const handleClosePopup = () => {
    setOpenPopUp("")
    setCanStart(false)
  }

  useEffect(() => {
    if (wrapperRef && disableScrollOnOpen) {
      if (open) {
        disableBodyScroll(wrapperRef)
      } else {
        clearAllBodyScrollLocks()
      }
    }
    return () => {
      clearAllBodyScrollLocks()
    }
  }, [wrapperRef, open, disableScrollOnOpen])

  useEffect(() => {
    if (wrapperRef) {
      setWrapperHeight(window.innerHeight)
    }
  }, [wrapperRef])

  return (
    <Wrapper
      onClick={!disableScrollOnOpen ? handleClosePopup : () => {}}
      onKeyUp={!disableScrollOnOpen ? handleClosePopup : () => {}}
      ref={ref => setWrapperRef(ref)}
      open={open}
      wrapperHeight={wrapperHeight}
      role="presentation"
    >
      <Close>
        <RoundButton
          large={large}
          ex
          onClick={disableScrollOnOpen ? handleClose : null}
        />
      </Close>
      {children}
    </Wrapper>
  )
}

const Wrapper = styled.dialog<{ open: boolean; wrapperHeight: number }>`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: ${({ wrapperHeight }) => wrapperHeight}px;
  background: ${colors.blue700}80;
  z-index: 2147483639; //one more than cookie policy
  top: 0;
  left: 0;
  opacity: ${({ open }) => (open ? 1 : 0)};
  pointer-events: ${({ open }) => (open ? "initial" : "none")};
  transition: 0.4s;
`

const Close = styled.div`
  position: absolute;
  z-index: 100;
  top: 6.944vw;
  right: 6.944vw;

  ${media.tablet} {
    top: auto;
    right: auto;
    bottom: 8%;
    left: 44.629vw;
  }

  ${media.mobile} {
    top: auto;
    right: auto;
    bottom: 5%;
    left: 42.133vw;
  }
`
